import React from "react";
import { Badge } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  label: string;
  hasErrors: boolean;
  hasChangedValues?: boolean;
};

export function TabBadge(props: Props) {
  const classes = useStyles({});

  if (!props.hasErrors && !props.hasChangedValues) {
    return <span>{props.label}</span>;
  }

  if (props.hasErrors) {
    return (
      <Badge color="error" badgeContent="!" classes={classes}>
        {props.label}
      </Badge>
    );
  }

  if (props.hasChangedValues) {
    return (
      <Badge color="error" badgeContent="N" classes={classes}>
        {props.label}
      </Badge>
    );
  }

  return null;
}

const useStyles = makeStyles((theme: ThemeType) => ({
  badge: {
    top: 0,
    right: -3,
    width: 20,
    height: 20,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600
  }
}));
